import { render } from "./ExportDataTable.vue?vue&type=template&id=31b0b213&scoped=true"
import script from "./ExportDataTable.vue?vue&type=script&lang=js"
export * from "./ExportDataTable.vue?vue&type=script&lang=js"

import "./ExportDataTable.vue?vue&type=style&index=0&id=31b0b213&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b0b213"]])

export default __exports__